import $ from 'jquery';
import cookies from 'js-cookie';
import './slick-carousel';
import './slick-slider';
import 'jquery-mask-plugin';
import './modal';
import './vanish/vanish';
import './toggle-display';
import './toggle-dropdown';
import './track-video';
import './accordion';
import './fixed-overlay';
import './fixed-scroll';
import './lazyload-image';
import './page-constrain';
import './back-to-top';
import './product-zoom';
import './horizontal-scroll';
import './progress-ring';
import './qr-code-toggle';
import ImageCarousel from './image-carousel';
import './tabs';
import './toggle-text';
import './slidedown';
import './side-panel';
import './product-filter-active-button';
import './product-filter-search';
import './product-filter-count';
import './product-filter-clear-all';
import './switch-class';
import './fixed-table-header';
import lazyload from './lazyload';
import './lazy-ajax';
import noFocus from './no-focus';
import './toggle-change';
import './toggle-reveal';
import './char-counter';
import './countdown';
import './gift-cert-update';
import './show-on-overflow';
import './cc-mask';
import './cc-exp-mask';
import './ntf-toast';
import './progressive-btn';
import './close-banner';
import './ab-controls';
import './impressions-controls';
import './rich-nav';
import './rating-scale/rating-scale';
import './cookies-banner';
import wishlistModule from '../../../../src/scripts/modules/wishlist';

// AB Test 899 HP / PDP Increase Slick Sensitivity
import { get } from '../lib/props';

/**
 *
 * AB Test 899 HP/PDP Increased Slick Sensitivity
 */
const increasedSensitivity = get('slick.slickSensitivity', false);

function setupLazyLoad() {
  lazyload({
    slideshowSettings: {
      arrows: false,
      infinite: true,
      mobileFirst: true,
      slidesToShow: 3,
      slidesToScroll: 2,
      lazyLoad: 'ondemand',
    },
  });
}

window.resetLazyLoad = function () {
  setupLazyLoad();
  $('.js-lazyload-slick').removeClass('js-lazyload-slick');
  $('.js-lazyload-image-lp').removeClass('js-lazyload-image-lp');
  $('.js-horizontal-scroll').horizontalScroll();
};

function setupHomeSlideshow() {
    var slideshow = $('#js-homepage-slideshow');
    slideshow.find(".slick-slideshow__slide").removeClass("u-hide");
    // Mock Content Start - AB Test 899 HP/PDP Increased Slick Sensitivity
    if (increasedSensitivity) document.body.classList.add('ab899-slick-sensitivity');
    // Mock Content End
    slideshow.slick({
    arrows: false,
    dots: true,
    infinite: true,
    mobileFirst: true,
    autoplay: false,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    lazyLoad: 'ondemand',
    // Mock Content Start - AB Test 899 HP/PDP Increased Slick Sensitivity
    touchThreshold: increasedSensitivity ? 20 : 5,
    vertical: false,
    verticalSwiping: false,
    // Mock Content End
  });
}

function setupBeautyLpSlideshow() {
  var slideshow = $('#js-beauty-lp-slideshow');
    slideshow.slick({
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    lazyLoad: 'ondemand',
    dotsClass: 'slick-dots--beauty',
  });
}

function setupBeautyTrendsSlideshow() {
  var slideshow = $('#js-beauty-trends-slideshow');
    slideshow.slick({
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    lazyLoad: 'ondemand',
    dotsClass: 'slick-dots--beauty',
  });
}


$.fn.navDropdowns = function( options ) {

    function toggleDropdown($el) {
        $el.find("ul").slideToggle("slow");
    }


    // Iterate and reformat each matched element.
    return this.each(function() {
        $(this).on("click", function(){
            toggleDropdown($(this));
        });
    });

};

$(document).ready(() => {
  noFocus();
  setupLazyLoad();
  $('.js-horizontal-scroll').horizontalScroll();
  $('.js-accordion').accordion({
    onComplete: function(){
      $('.js-fixed-table-header').fixedTableHeader('check');
    }
  });
  $('.js-accordion-open-trigger').on('click', function(e) {
    e.preventDefault;
    $(".js-accordion-open").accordion('openPanel', '#js-accordion-open-target');
  });
  // $('.product-option--size .product-option__select').sizeChange();
  // $('.product-option--color .product-option__select').colorChange();
  // $('.btn--add-to-bag').addToBag();
  // $('.product-option--oos').oosProduct();
  $('.js-countdown').countdown();
  $('.js-show-on-overflow').showOnOverflow();
  $('.js-gfc-update').giftCertUpdate();
  $('.js-lazyload-image').lazyLoadImage();
  $('.js-progress-ring').progressRing();
  $('.js-toggle-display').toggleDisplay();
  $(".js-track-video").trackVideo();
  $('.js-modal').modal();
  $.modal.a11y();
  $('.js-char-counter').charCounter();
  $('.js-close-banner').closeBanner();
  $('.js-slidedown').slidedown();
  $(".js-carousel").slickSlider();
  $('.js-mask-cc').ccMask();
  $('.js-progressive-btn').progressiveBtn();
  $('.js-cookies-banner-toggle').cookiesBanner();
  $('.js-carousel-single-slide').slick({
      dots: false,
      infinite: true,
      fade: true,
      arrows: false,
      cssEase: 'linear',
      autoplay: true,
      autoplaySpeed: 1500,
   });
  $('.js-carousel-dress-edit').slickSlider({
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });
  // Global Banner slider
  const banerSlideshow = $('.js-slideshow');
  if (banerSlideshow.children('.banner--slider-list__item').length > 1) {
    banerSlideshow.slick({
      autoplay: true,
      autoplaySpeed: 6000,
      prevArrow: '.banner__slick-prev',
      nextArrow: '.banner__slick-next',
    });
    $('.banner__slick-next, .banner__slick-prev').on('click', () => {
      banerSlideshow.slick('slickPause');
    });
  }

  // $(".js-homepage-slideshow").slickSlider();
  $('#js-nav-dropdown').navDropdowns();
  $('#js-nav-dropdown--full').navDropdowns();
  $('.js-fixed-overlay').fixedOverlay();
  $('.js-switch-class').switchClass();
  $('.js-toggle-text').toggleText();
  $('.js-fixed-table-header').fixedTableHeader();
  setupHomeSlideshow();
  setupBeautyLpSlideshow();
  setupBeautyTrendsSlideshow();
  $('.js-toggle-change').toggleChange();
  $('.js-toggle-dropdown').toggleDropdown();

  // input mask
  if ($('.js-mask-tel-us').length) {
    $('.js-mask-tel-us').mask('(000) 000-0000');
  }
  if ($('.js-mask-date').length) {
    $('.js-mask-date').mask('00/00/0000');
  }
  if($('.js-mask-month-day').length) {
    $('.js-mask-month-day').mask('00/00')
  }
  $('.js-fixed-scroll').fixedScroll();
  $('.js-toggle-reveal').toggleReveal();
  $('.js-site-footer-qr-btn').qrCodeToggle();
  $('.js-tabs').tabs({
   onShow: function(){
     $('.js-fixed-table-header').fixedTableHeader('check');
   }
  });
  $('.js-ab-controls').abControls(); // Ab Testing Controls for previewing on testing servers
  // for all inclusive modal
  $('.js-duties-modal').on('click', function() {
    $.modal({
      url: '/fw/mobile/dialog/AllInclusiveModal.jsp',
      triggerOpen: open,
      type: 'toast',
    });
  });

  // Initialize lazy load on image with class name
  $('.js-lazy-image').lazy({
    effect: 'fadeIn',
  });

  // for all inclusive banner modal
  // check's if banner exists for all inclusive
  if($('#fwDutyBanner').length > 0) {
    if (!cookies.get("all_inclusive_modal")){
      // no cookie, open modal
      $.modal({
        url: '/fw/mobile/dialog/AllInclusiveModal.jsp',
        triggerOpen: open,
        type: 'toast',
        onComplete: function() {
          cookies.set('all_inclusive_modal', true, { expires: 7 })
        }
      });
    }
  }
  $('.js-impressions-controls').impressionsControls();
  $('#js-rich-nav').richNav();
  wishlistModule.bindWishListEvent();

  //JS for Input - Floating Label interaction
  function updateText(event){
    var input=$(this),
        closebtn = input.siblings('.close-btn'),
        val = input.val();

    if(val!=""){
        input.parent().addClass("field--floating-float");
    }else{
        input.parent().removeClass("field--floating-float");
    }

    if(input.is(':focus') && val!=""){ //Show close button if input is in focus w/ text
        closebtn.show();
    }else if(input.is(':focus') && val==""){ //Hide close button if input is in focus w/o text
        closebtn.hide();
    }

    //Timeout Set to avoid close buttton from disappearing before intentionally clicking it
    setTimeout(function(){
        if( (!input.is(':focus')) && val!=""){ //Hide close buttton if Input is no longer in focus but contains text
            closebtn.hide();
        }
    }, 200)
  }
  $(".field--floating input").keydown(updateText);
  $(".field--floating input").change(updateText);

  function clearInput(event){
      var closeBtn = $(this);
      closeBtn.siblings('input').val('');
      $(this).parent().removeClass("field--floating-float");
      closeBtn.hide();
  }
  $(".close-btn").on('click', clearInput);

  // Validation needed

  // if invalid add class of .is-error
  //hide close btn / show exclamation icon

  // if more detail needed add class .is-more-detail
  // hide close btn / show question mark link
  function filterSetup() {
    // Event for clicking on overlay on title dropdown
    var $pageHeaderOverlay = $(".js-page-header-overlay");
    var $pageHeaderTitle = $(".page-header__title");
    $pageHeaderOverlay.on("click", function () {
        $pageHeaderTitle.click();
    });
  }
  filterSetup();
  $('.vanish').vanish();

  // Image Carousels
  const IMAGE_CAROUSEL_SELECTOR = '.image-carousel';
  const PRODUCT_ZOOM_SELECTOR = `${IMAGE_CAROUSEL_SELECTOR}--product-zoom`;
  const $imageCarousel = $(IMAGE_CAROUSEL_SELECTOR);

  $imageCarousel
    .filter(`:not(${PRODUCT_ZOOM_SELECTOR})`)
    .imageCarousel();

  $imageCarousel
    .filter(PRODUCT_ZOOM_SELECTOR)
    .each(function setupZoomCarousel() {
      let carousel;
      if ($(this).hasClass('badge-on-top')) {
        carousel = new ImageCarousel(this, {
          dots: true,
        });
      } else {
        carousel = new ImageCarousel(this);
        $('.product__image .image-carousel__counter').show();
      }
      $(this).productZoom({
        slideFunc: carousel.setSlideNumber.bind(carousel),
        beforeUnmount: carousel.transitionSlide.bind(carousel),
        targetSelector: 'img',
      });
    });

  // footer country preferences
  $('.js-view-country-preferences').on('click', function() {
    $.modal({
      url: '/fw/content/user/countryPreferences',
      triggerOpen: open,
      type: 'toast',
      triggerElement: $(this),
    });
  });

    // Launch Hero Slider
    $('.js-slick-launches').each(function () {
        const $this = $(this);
        $this.slick({
            dots: true,
            appendDots: $this.find('.js-pagination-dots'),
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 3000,
        }).on('afterChange', function (event, slick, currentSlide) {
            $.each(slick.$dots, (i, el) => {
                $(el).find('li').eq(currentSlide).addClass('slick-active').find('button');
            })
        });
    });

}); // End Document Ready



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/modules.js